import { Injectable } from '@angular/core';
import { PropositionStatus } from '../../entities/master-proposal/master-proposal.model';
import { isUndefined } from 'util';
/**
 * Created by A665445 on 26/04/2017.
 */
export interface MultiSelectOption {
    value: any;
    label: string;
}

export const STUDENT_HISTORY_PROPOSAL: MultiSelectOption[] = [
    { label: 'Transmise étudiant', value: PropositionStatus.TRANSMITTED },
    { label: 'Refusée étudiant', value: PropositionStatus.REFUSED },
    { label: 'Confirmée étudiant', value: PropositionStatus.CONFIRMED }
];

export const SCHOOL_HISTORY_PROPOSAL: MultiSelectOption[] = [
    { label: 'Soumise établissement', value: PropositionStatus.SUBMITTED },
    { label: 'Acceptée établissement', value: PropositionStatus.ACCEPTED },
    { label: 'Rejetée établissement', value: PropositionStatus.REJECTED },
    { label: 'Annulée', value: PropositionStatus.CANCELED }
];

export const SCHOOL_PROPOSAL: MultiSelectOption[] = [
    { label: 'Soumise établissement', value: PropositionStatus.SUBMITTED },
    { label: 'Acceptée établissement', value: PropositionStatus.ACCEPTED },
    { label: 'Rejetée établissement', value: PropositionStatus.REJECTED },
    { label: 'Transmise étudiant', value: PropositionStatus.TRANSMITTED },
    { label: 'Refusée étudiant', value: PropositionStatus.REFUSED },
    { label: 'Confirmée étudiant', value: PropositionStatus.CONFIRMED },
    { label: 'Annulée', value: PropositionStatus.CANCELED }
];

export const ALL_PROPOSALS: MultiSelectOption[] = [
    { label: 'Soumise établissement', value: PropositionStatus.SUBMITTED },
    { label: 'Acceptée établissement', value: PropositionStatus.ACCEPTED },
    { label: 'Rejetée établissement', value: PropositionStatus.REJECTED },
    { label: 'Transmise étudiant', value: PropositionStatus.TRANSMITTED },
    { label: 'Refusée étudiant', value: PropositionStatus.REFUSED },
    { label: 'Confirmée étudiant', value: PropositionStatus.CONFIRMED },
    { label: 'Annulée', value: PropositionStatus.CANCELED }
];

export const RxA_DIALOGUE: MultiSelectOption[] = [
    { label: 'Soumise établissement', value: PropositionStatus.SUBMITTED },
    { label: 'Acceptée établissement', value: PropositionStatus.ACCEPTED },
    { label: 'Rejetée établissement', value: PropositionStatus.REJECTED },
    { label: 'Annulée', value: PropositionStatus.CANCELED }
];

export const ALL_SAISINE_STATUS: MultiSelectOption[] = [
    { label: 'Brouillon', value: 'IN_PROGRESS' },
    { label: 'A vérifier', value: 'TO_CHECK' },
    { label: 'Rejetée', value: 'REJECTED' },
    { label: 'Vérifiée', value: 'CHECKED' },
    { label: 'Traitée', value: 'TREATED' },
    { label: 'Abandonnée', value: 'ABANDONED' },
    { label: 'Close', value: 'CLOSED' },
    { label: 'Annulée', value: 'CANCELED' }
];

export const SAISINE_STATUS: MultiSelectOption[] = [
    { label: 'Brouillon', value: 0 },
    { label: 'A vérifier', value: 1 },
    { label: 'Rejetée', value: 2 },
    { label: 'Vérifiée', value: 3 },
    { label: 'Traitée', value: 4 },
    { label: 'Abandonnée', value: 5 },
    { label: 'Close', value: 6 },
    { label: 'Annulée', value: 7 }
];


export const EMPTY_OPTION: MultiSelectOption = { label: '', value: '' };

@Injectable()
export class UtilsService {

    constructor() { };

    scrollToTop(): void {
        window.scrollTo(0, 0);
    }

    deleteBckgrnd(): void {
        window.document.getElementsByTagName('body').item(0).removeAttribute('class');
    }

    setBckgrnd(): void {
        window.document.getElementsByTagName('body').item(0).setAttribute('class', 'publicSpace');
    }

    getAllPropositionStatus(): any {
        return ALL_PROPOSALS;
    }

    getRxADialogueStatus(): any {
        return RxA_DIALOGUE;
    }

    getEtablissementPropositionOptions(): any {
        return SCHOOL_HISTORY_PROPOSAL;
    }

    getEtabPropositionOptions(): any {
        return SCHOOL_PROPOSAL;
    }

    getStudentHistoryPropositionOptions(): any {
        return STUDENT_HISTORY_PROPOSAL;
    }

    getAllSaisineStatus(): any {
        return ALL_SAISINE_STATUS;
    }

    getAuthoritiesString(authoritiesUser): string {
        let stringAuthorities = '';
        let authorities: Map<string, string> = new Map<string, string>();
        authorities.set('ROLE_ADMIN', 'Administrateur');
        authorities.set('ROLE_MINISTRY', 'Ministère');
        authorities.set('ROLE_ACADEMICREGIONRECTOR', 'Recteur région académique');
        authorities.set('ROLE_ACADEMICRECTOR', 'Recteur académique');
        authorities.set('ROLE_SCHOOL_ADMIN', 'Etablissement (administrateur)');
        authorities.set('ROLE_SCHOOL_MANAGER', 'Etablissement (gestionnaire)');
        authorities.set('ROLE_SCHOOL_CONSULT', 'Etablissement (en consultation)');
        authorities.set('ROLE_STUDENT', 'Etudiant');

        authoritiesUser.forEach(auth => {
            if (!isUndefined(authorities.get(auth))) {
                if (stringAuthorities.length !== 0) {
                    stringAuthorities += ', ';
                }
                stringAuthorities += authorities.get(auth);
            }
        });
        return stringAuthorities;
    }


    datatableInitFilters(datatable) {
        datatable.reset();
        datatable._filter();
    }

    datatableReapplyInitSortFilters(datatable, multiSortMeta) {
        this.datatableInitFilters(datatable);
        datatable.multiSortMeta = multiSortMeta;
        datatable.sortMultiple();
    }


    datatableExportCSV(datatable, options) {
        let transcoStatusOptions = options;
        // valeurs filtrees
        let data = datatable.filteredValue || datatable.value;
        let csv = '\uFEFF';
        // headers
        for (let i = 0; i < datatable.columns.length; i++) {
            if (datatable.columns[i].field) {
                csv += datatable.columns[i].header || datatable.columns[i].field;
                if (i < (datatable.columns.length - 1)) {
                    csv += datatable.csvSeparator;
                }
            }
        }
        // body
        data.forEach(function (record, i) {
            csv += '\n';
            for (let i_1 = 0; i_1 < datatable.columns.length; i_1++) {
                if (datatable.columns[i_1].field) {
                    let val = datatable.resolveFieldData(record, datatable.columns[i_1].field);
                    if (val == null) {
                        val = '';
                    } else if (val === false || val === true) {
                        val = val ? 'oui' : 'non';
                    } else if ('status' === datatable.columns[i_1].field) {
                        for (let i_2 = 0; i_2 < transcoStatusOptions.length; i_2++) {
                            if (transcoStatusOptions[i_2].value === val) {
                                val = transcoStatusOptions[i_2].label;
                                break;
                            }
                        }
                    } else if (datatable.columns[i_1].field && datatable.columns[i_1].field.toLowerCase().indexOf('date') !== -1) {
                        // entete contient le mot date, il faut transformer en format date fr
                        let ymd = val.toString().slice(0, 10).split('-');
                        val = '' + ymd[2] + '/' + ymd[1] + '/' + ymd[0];
                    } else if (isNaN(val)) {
                        // valeur texte, remplacer les br par retour charriot
                        val = val.replace(/<br\/\>/gi, '\n');
                        // les doubles quotes posent problemes à l'export, il faut les doublées pour que celles-ci soient affichées
                        val = val.replace(/\"/g, '\"\"');
                    } else {
                        // c'est un nombre, il faut ajouter '' pour qu excel affiche en tant que texte
                        val = '' + val;
                    }

                    csv += '"' + val + '"';
                    if (i_1 < (datatable.columns.length - 1)) {
                        csv += datatable.csvSeparator;
                    }
                }
            }
        });
        let blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, datatable.exportFilename + '.csv');
        } else {
            let link = document.createElement('a');
            link.style.display = 'none';
            document.body.appendChild(link);
            if (link.download !== undefined) {
                link.setAttribute('href', URL.createObjectURL(blob));
                link.setAttribute('download', datatable.exportFilename + '.csv');
                link.click();
            } else {
                csv = 'data:text/csv;charset=utf-8,' + csv;
                window.open(encodeURI(csv));
            }
            document.body.removeChild(link);
        }
    }

    traitementExportDataTable(datatable) {
        datatable.forEach(record => {
            for (let i = 0; i < datatable[0].length; i++) {
                if (record[i] == null) {
                    record[i] = '';
                } else if (record[i] && record[i] !== datatable[0][i] && datatable[0][i].toLowerCase().indexOf('date') !== -1) {
                    // entete contient le mot date, il faut transformer en format date fr
                    let ymd = record[i].toString().slice(0, 10).split('-');
                    record[i] = '' + ymd[2] + '/' + ymd[1] + '/' + ymd[0];
                } else if (isNaN(record[i])) {
                    // valeur texte, remplacer les br par retour charriot
                    record[i] = record[i].replace(/<br\/\>/gi, '\n');
                }
            }
        });
        return datatable;
    }

    filter(datalist: string[], event): string[] {
        let returnedList = [];
        if (!event || !event.query) {
            return datalist.slice(1, 200);
        }
        let searchValue = event.query.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        for (let data of datalist) {
            if (data.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(searchValue)) {
                returnedList.push(data);
                if (returnedList.length > 200) {
                    return returnedList;
                }
            }
        }
        return returnedList;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/utils.service.ts